import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import jwt_decode from "jwt-decode";
import { AppConfig } from '../common/app.config';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isLoggedin: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly http: HttpClient,
    private readonly zone: NgZone,
    private readonly storage: LocalStorageService,
    private readonly toastr: ToastrService) {
  }

  async handleCredentialResponse(response: any) {
    // Here will be your response from Google.
    let signInResponse: any = jwt_decode(response.credential);
    console.log(response)
    console.log(response.credential)
    this.isLoggedin = (signInResponse != null);
    if (signInResponse == null) {
      this.storage.store('isloggedin', false);
      this.router.navigate(['/login']);
    } else {
      this.zone.run(() => {
        this.storage.store('loginobj', signInResponse);
        this.storage.store('isloggedin', true);
        this.router.navigate(['/home']);
      });
    }
  }

  ngOnInit(): void {
    const emailSession: any = this.storage.retrieve('loginobj');
    if (emailSession) {
      this.router.navigate(['/home']);
    }
    else {
      // @ts-ignore

      google.accounts.id.initialize({
        client_id: AppConfig.prod.clientId,
        callback: this.handleCredentialResponse.bind(this),
        auto_select: false,
        cancel_on_tap_outside: true,
        auto_prompt: false
      });
      // @ts-ignore
      google.accounts.id.renderButton(
        // @ts-ignore
        document.getElementById("google-button"),
        { theme: "outline", size: "large", width: "100%" }
      );
      // @ts-ignore
      // google.accounts.id.prompt((notification: PromptMomentNotification) => { });
    }
  }
}